import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Grid, Row, Col } from 'react-flexbox-grid';

const Wrapper = styled.div`
  color: #fff;
  background: #333333;
  padding: 0;
  margin: 0;
  padding-bottom: 25px;
  padding-top: 25px;
  text-align: left;
`;

const Copyright = styled.div`
  p {
    text-align: center;
    font-size: 80%;
    margin-bottom: 0;
  }
`;

const PrivacyPolicy = styled.div`
  p {
    margin: 0;
    padding: 0;
    text-align: center;
    font-size: 80%;
  }
`;

class Home extends Component {
  render() {
    return (
      <Wrapper>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <Copyright>
                <p>Copyright © 2018-2019 Blockscale LLC - <a href="mailto:contact@blockscale.net">Contact</a></p>
              </Copyright>
              <PrivacyPolicy>
                <p><Link to="/privacy-policy">Privacy Policy</Link></p>
              </PrivacyPolicy>
            </Col>
          </Row>
        </Grid>
      </Wrapper>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/App/Footer/index.js